export class veeCustomValidator {
  static init(VeeValidate) {
    const check_card_number_required_Rule = "check-Card-number_required";
    const check_card_expiration_required_Rule =
      "check-Card_expiration_required";
    const check_card_cvc_required_Rule = "check-Card-cvc_required";
    const check_card_number_Rule = "check-Card-number";
    const check_card_expiration_Rule = "check-Card-expiration";
    const check_card_cvc_Rule = "check-Card-cvc";

    VeeValidate.Validator.extend(check_card_number_required_Rule, {
      getMessage: () => "Number of Card Info field is required.",
      validate(value) {
        return !(
          value.number == null ||
          value.number === undefined ||
          value.number.trim() == ""
        );
      }
    });
    VeeValidate.Validator.extend(check_card_expiration_required_Rule, {
      getMessage: () => "Expiry Date of Card Info field is required.",
      validate(value) {
        return !(
          value.expiration == null ||
          value.expiration === undefined ||
          value.expiration.trim() == ""
        );
      }
    });
    VeeValidate.Validator.extend(check_card_cvc_required_Rule, {
      getMessage: () => "CVV of Card Info field is required.",
      validate(value) {
        return !(
          value.cvc == null ||
          value.cvc === undefined ||
          value.cvc.trim() == ""
        );
      }
    });

    VeeValidate.Validator.extend(check_card_number_Rule, {
      getMessage: () => "Number of Card Info Field is invalid.",
      validate(value) {
        return value.isValidedNumber;
      }
    });
    VeeValidate.Validator.extend(check_card_expiration_Rule, {
      getMessage: () => "Expiry Date of Card Info Field is invalid.",
      validate(value) {
        return value.isValidedExoiredDate;
      }
    });
    VeeValidate.Validator.extend(check_card_cvc_Rule, {
      getMessage: () => "CVV of Card Info Field is invalid.",
      validate(value) {
        return value.isValidedCVC;
      }
    });
    VeeValidate.Validator.extend('cardholder', (value) => {
      const wrongLength = value.length < 2 || value.length > 40;
      if(wrongLength) {
        return false;
      }

      for (let i = 0, len = value.length; i < len; i++) {
        let code = value.charCodeAt(i);
        if (!(code == 32 || code == 45) && // space and hyphen
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123) // lower alpha (a-z)
          ) {
          return false;
        }
      }
      return true;
    });
  }
}
